module.exports = "/_next/static/images/7d859b8e055329e17201553f8bf2832d-balance-xs.png";